import { render, staticRenderFns } from "./adsTabPage.vue?vue&type=template&id=6d8415b4&scoped=true"
import script from "./adsTabPage.vue?vue&type=script&lang=js"
export * from "./adsTabPage.vue?vue&type=script&lang=js"
import style0 from "./adsTabPage.vue?vue&type=style&index=0&id=6d8415b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8415b4",
  null
  
)

export default component.exports